import { Select } from "antd"
import { FC } from "react"
import { ROLES_ENUM } from "../../../types/role"

interface ISelectAccessPage {
  roles: [string]
  setRoles: (accesesPages: [string]) => void
}

const SelectRoles: FC<ISelectAccessPage> = ({ setRoles, roles }) => {
  const selectOptions = [
    {
      label: "User",
      value: ROLES_ENUM.USER,
    },
  ]

  function onChange(value: [string]) {
    setRoles(value)
  }

  return (
    <Select
      mode="tags"
      placeholder="Role"
      optionFilterProp="label"
      showSearch
      options={selectOptions}
      defaultValue={roles}
      onChange={onChange}
    />
  )
}

export default SelectRoles
